export function getTimeStampWithMillis(): string {
  const now = new Date();
  const hours = now.getHours();
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const milliseconds = now.getMilliseconds();

  return `${hours}:${minutes}:${seconds}:${milliseconds}`;
}
